import React from 'react'
import config from 'config'

import RichCta from 'components/rich-cta'
import StudentLoanCombinedForm from 'components/form/student-loan-combined'
import WidgetPage from 'components/hocs/widget-page'

export const RichCtaApp = (props) => (
  <RichCta
    url={`${config.credibleRoot}/refinance-student-loans`}
    title="Save money with the right private student loan."
    body="Compare rates in minutes without affecting your credit."
    ctaText="Get Started"
    form={StudentLoanCombinedForm}
    {...props}
  />
)

export default WidgetPage(RichCtaApp)
